<p-toast position="top-right" key="msj"></p-toast>
<!--<p-messages></p-messages>-->
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" acceptLabel="Aceptar" rejectLabel="Cancelar"
  rejectButtonStyleClass="p-button-text"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
  rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar"
  [rejectVisible]="false"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="folio" [baseZIndex]="10000" acceptLabel="Aceptar" rejectLabel="Cancelar"
  rejectButtonStyleClass="p-button-text" styleClass="color-confirmar" [rejectVisible]="false"></p-confirmDialog>
<div class="d-flex justify-content-center">
  <div class="container-fluid">
    <div class="row mt-3">
      <div class="col-md-12">
        <div class="card card-shadow sinborde">
          <div class="card-header sinborde" style="background: none; ">
            <div class="cardicono rounded">
              <i class="pi pi-sun mt-3" style="font-size: 2rem; color: #fff;"></i>
            </div>
            <header style="left: 11%; top: 5%;">
              <div style="display:inline">Operación Diaria Real</div>
              <div *ngIf="dia.length > 0" style="color:#834aed;display:inline;" class="ml-3"> - {{dia |
                date: 'dd/MM/yyyy'}} </div>
            </header>
            <div class="row d-flex justify-content-end">
              <div class="col-md-12">
                <div class="form-group row mt-5">
                  <div class="col-md-6">
                    <div class="row d-flex justify-content-center">
                      <div class="col-md-2"></div>
                      <div class="col-md-2 d-flex align-items-center">
                        <i class="pi pi-calendar color-icon me-2" style="font-size: 2rem; color: #3B82F6;"></i>
                        <span class="d-none d-xl-inline mt-2"><b>Fecha</b></span>
                      </div>

                      <div class="col-md-4">
                        <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha"
                          tooltipPosition="top" [(ngModel)]="fecha_filtrada" (onChange)="asignarValorFecha()">
                        <hr class="my-1">
                      </div>
                      <!-- <div class="col-md-1 d-flex justify-content-start"></div> -->
                      <div class="col-md-3 ml-3 d-flex justify-content-start">
                        <button class="custom-buttoncargar" pButton pRipple type="button"
                          (click)="FiltrarFechaDiariaRuta();" icon="pi pi-filter" iconPos="right"> <span
                            class="d-none d-lg-inline"><b>&nbsp;Filtrar&nbsp;</b></span></button>


                      </div>

                    </div>
                  </div>


                  <div class="d-flex justify-content-center col-md-6 gap-2">
                    <button pButton pRipple type="button" (click)="cargarsinruta();" class="custom-sin"
                      icon="pi pi-plus-circle" iconPos="right">
                      <span class="d-none d-lg-inline"><b>&nbsp;Servicio Sin&nbsp;Ruta</b></span>
                    </button>

                    <button pButton pRipple type="button" (click)="dialogServicio();" class="custom-cancelar"
                      icon="pi pi-check" iconPos="right">
                      <span class="d-none d-lg-inline"><b>&nbsp;Comprobación</b></span>
                    </button>

                    <button pButton pRipple type="button" (click)="ConsultarCriterio();" class="custom-Criterio"
                      icon="pi pi-arrow-up-right" iconPos="right">
                      <span class="d-none d-lg-inline"><b>&nbsp;Consultar&nbsp;Criterio</b></span>
                    </button>

                    <button pButton pRipple type="button" (click)="consultarMantenimiento();" class="custom-Mantenimiento"
                      icon="pi pi-wrench" iconPos="right">
                      <span class="d-none d-lg-inline"><b>&nbsp;Consultar&nbsp;Mantenimiento</b></span>
                    </button>
                  </div>



                </div>
              </div>
            </div>
          </div>
          <div class="card-content">
            <div class="row mt-5">
              <p-table #dt1 [value]="lstOperacionDiariaReal" dataKey="id" editMode="row" [scrollable]="true"
                scrollDirection="both" scrollHeight="600px" [ngStyle]="{'min-width': '100%', 'max-width': '100%'}"
                [globalFilterFields]="['nombre_ciudad','nombre_cliente','nombre_ruta','nombre_tipo_transporte','id_ruta']"
                [loading]="loading" [paginator]="true" [rows]="50" [rowsPerPageOptions]="[50,150,100,200]"
                [showCurrentPageReport]="true" currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
                sortField="nombre_ciudad">
                <ng-template pTemplate="caption">

                  <div class="row">
                    <!-- Filtros -->
                    <div class="col-md-10">
                      <div class="row d-flex justify-content-end align-items-center">
                        <div class="col-md-3">
                          <p-columnFilter type="text" field="nombre_ciudad" placeholder="Ciudad"
                            class="form-control sinborde filtro" matchMode="contains"></p-columnFilter>
                        </div>
                        <div class="col-md-3">
                          <p-columnFilter type="text" field="nombre_cliente" placeholder="Cliente"
                            class="form-control sinborde filtro" matchMode="contains"></p-columnFilter>
                        </div>
                        <div class="col-md-3">
                          <p-columnFilter type="text" field="nombre_proyecto" placeholder="Proyecto"
                            class="form-control sinborde filtro" matchMode="contains"></p-columnFilter>
                        </div>
                        <div class="col-md-3 d-flex">
                          <div class="p-input-icon-left w-100 mt-1">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" class="form-control"
                              (input)="applyFilterGlobal($event, 'contains')" placeholder="Buscar Ruta" />
                          </div>
                        </div>

                      </div>
                    </div>

                    <!-- Botón Limpiar Filtros -->
                    <div class="col-md-2 d-flex justify-content-start  align-items-center">
                      <button class="btn custom-del" (click)="limpiarfiltrosTabla();">
                        <span class="d-none d-lg-inline">Limpiar&nbsp;Filtros&nbsp;</span><i class="pi pi-trash"></i>
                      </button>
                    </div>
                  </div>



                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="nombre_ciudad" class="text-center" [ngClass]="{'texto_sm':true}"
                      style="min-width:100px; width: 100px;">Ciudad
                      <p-sortIcon field="nombre_ciudad"></p-sortIcon>
                    </th>
                    <th pSortableColumn="nombre_ruta" class="text-center" [ngClass]="{'texto_sm':true}"
                      style="min-width:100px; width: 180px;">Ruta
                      <p-sortIcon field="nombre_ruta"></p-sortIcon>
                    </th>

                    <th pFrozenColumn pSortableColumn="num_proyeccion" [ngClass]="{'texto_sm':true}"
                      style="min-width:40px; width: 40px;" class="text-center">
                      Programado<p-sortIcon field="num_proyeccion"></p-sortIcon>
                    </th>
                    <th pFrozenColumn pSortableColumn="num_real" [ngClass]="{'texto_sm':true}"
                      style="min-width:90px; width: 90px;" class="text-center">
                      Prestado<p-sortIcon field="num_real"></p-sortIcon>
                    </th>
                    <th class="text-center"
                      [ngStyle]="this.clv_operacion == 3 ? {'text-align': 'center', 'min-width': '210px', 'width': '230px'} : {}"
                      [ngClass]="{'texto_sm':true}">Unidad
                    </th>
                    <!-- <th *ngIf="clv_pa != 0 && fecha_filtrada!=fecha_dia_final" class="text-center"
                      style="min-width:120px;width: 120px;" [ngClass]="{'texto_sm':true}">Admi
                    </th> -->
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr>
                    <td class="text-center" style="min-width:100px; width: 100px;" [ngClass]="{'col-header':true}">
                      {{rowData.nombre_ciudad}}
                    </td>


                    <td style="min-width:200px; width: 200px;"
                      [ngClass]="{'col-header':true,'col-especial':rowData.clv_especial==1,'texto_sm':true}">
                      {{rowData.nombre_ruta}}
                    </td>

                    <td style="min-width:40px; width: 40px;" [ngClass]="{'col-lila':true}">
                      <div class="row d-flex justify-content-center">

                        <div class="col-sm-3">
                          <h4 pTooltip="Numero de Servicios" tooltipPosition="top" class="text-center font-weight-bold">
                            {{rowData.num_proyeccion}}
                          </h4>
                        </div>
                      </div>
                    </td>
                    <td style="min-width:90px; width: 90px;">
                      <div class="row  g-0">
                        <div class="col-sm-12" *ngIf="rowData.num_real>0">
                          <div class="row d-flex justify-content-center">
                            <div class="col-sm-4 d-flex justify-content-center">
                              <p-checkbox [(ngModel)]="checked" [binary]="true" inputId="binary"
                                [disabled]="true"></p-checkbox>
                            </div>
                            <div class="col-sm-4 d-flex justify-content-center">
                              <h4 class="font-weight-bold" pTooltip="Numero de Servicios" tooltipPosition="top">
                                {{rowData.num_real}}</h4>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12" *ngIf="rowData.num_real<=0">
                          <div class="row d-flex justify-content-center">
                            <div class="col-sm-4 d-flex justify-content-center">
                              <p-checkbox [(ngModel)]="checked2" [binary]="true" inputId="binary"
                                [disabled]="true"></p-checkbox>
                            </div>
                            <div class="col-sm-4 d-flex justify-content-center">
                              <h4 class="font-weight-bold" pTooltip="Numero de Servicios" tooltipPosition="top">
                                {{rowData.num_real}}</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <!--CON TABULADOR-->
                    <!-- <td style="text-align:center; min-width:210px;width: 230px;" *ngIf="rowData.clv_tabulado==1"> -->

                    <td *ngIf="rowData.clv_tabulado==1"
                      [ngStyle]="this.clv_operacion == 3 ? {'text-align': 'center', 'min-width': '210px', 'width': '230px'} : {}">
                      <div class="row g-0 justify-content-center ">
                        <div class="col-sm-2">
                          <button pButton type="button" icon="pi pi-plus-circle" class="p-button-rounded  p-button-text"
                            pTooltip="Agregar servicio Normal" tooltipPosition="top"
                            (click)="agregarUnidadxDia(rowData, 0, 1)" [disabled]="!this.credsOpciones.clv_create">
                          </button>
                        </div>
                        <!--div class="col-sm-2">
                          <button pButton type="button" icon="pi pi-plus-circle"
                            class="p-button-rounded p-button-text p-button-help" pTooltip="Comprobacion de Servicios no finalizados"
                            tooltipPosition="top" (click)="ComprobarServicio(rowData)"
                            [disabled]="!this.credsOpciones.clv_create">
                            <p class="pl-1 my-0" style="font-size: 9px;">Comprobacion</p>
                          </button>
                        </!--div-->
                        <div class="col-sm-3" *ngIf="this.clv_operacion == 3">
                          <button pButton type="button" icon="pi pi-plus-circle"
                            class="p-button-rounded p-button-text p-button-danger" pTooltip="Agregar servicio Sin Cobro"
                            tooltipPosition="top" (click)="agregarUnidadxDia(rowData,2,2)"
                            [disabled]="!this.credsOpciones.clv_create">
                            <p class="pl-1 my-0" style="font-size: 9px;">Sin cobro</p>
                          </button>
                        </div>
                        <div class="col-sm-3" *ngIf="this.clv_operacion !== 3"></div>
                        <div class="col-sm-3" *ngIf="this.clv_operacion == 3">
                          <button pButton type="button" icon="pi pi-plus-circle"
                            class="p-button-rounded p-button-text p-button-contrast"
                            pTooltip="Agregar servicio Sin Nomina" tooltipPosition="top"
                            (click)="agregarUnidadxDia(rowData,3,2)" [disabled]="!this.credsOpciones.clv_create">
                            <p class="pl-1 my-0" style="font-size: 9px;">Sin Nomina</p>
                          </button>
                        </div>
                        <!-- autorizacion especial button -->
                        <!-- <div class="col-sm-3" *ngIf="this.clv_operacion == 3 || this.clv_operacion == 1"> -->
                        <div class="col-sm-3" *ngIf="this.clv_operacion == 3 || this.clv_operacion == 1">
                          <button pButton type="button" icon="pi pi-plus-circle"
                            class="p-button-rounded p-button-text p-button-secondary" pTooltip="Autorización Especial"
                            tooltipPosition="top" (click)="agregarUnidadxDia(rowData,4,5)"
                            [disabled]="!this.credsOpciones.clv_create">
                            <p class="pl-1 my-0" style="font-size: 9px;">Autorización Especial</p>
                          </button>
                        </div>
                        <div class="col-sm-3" *ngIf="this.clv_operacion === 1"></div>
                        <div class="col-sm-1">
                          <button pButton type="button" icon="pi pi-align-justify"
                            class="p-button-rounded p-button-warning p-button-text" pTooltip="Ver Servicios"
                            tooltipPosition="top" (click)="consultaInformacionDeUnidades(rowData);"
                            [disabled]="rowData.num_real<=0"></button>
                        </div>
                      </div>
                    </td>
                    <!--FIN CON TABULADOR-->
                    <!--SIN TABULADOR (DESACTIVADO)-->
                    <td style="text-align:center; min-width:120px;width: 120px;" *ngIf="rowData.clv_tabulado==0">
                      <div class="row g-0">
                        <div class="col-sm-3">
                          <p class="col-especial">
                            <i class="pi pi-times" pTooltip="Sin Tabulador"></i>
                          </p>
                        </div>
                        <div class="col-sm-6">
                          <p class="col-especial">
                            <i class="pi pi-times" pTooltip="Especial-Sin Tabulador"></i>
                          </p>
                        </div>
                        <div class="col-sm-3">
                          <button pButton type="button" icon="pi pi-align-justify"
                            class="p-button-rounded p-button-warning p-button-text" pTooltip="Ver Servicios"
                            tooltipPosition="left" (click)="consultaInformacionDeUnidades(rowData);"
                            [disabled]="rowData.num_real<=0"></button>
                        </div>
                      </div>
                    </td>
                    <!--FIN SIN CON TABULADOR (DESACTIVADO)-->
                    <!-- <td *ngIf="clv_pa == 6 && fecha_filtrada!=fecha_dia_final">
                      <div class="row d-flex justify-content-center">
                        <div class="col-sm-3 d-flex justify-content-center">
                          <button pButton type="button" icon="pi pi-plus-circle" class="p-button-rounded p-button-text"
                            pTooltip="Agregar Normal-Admin" tooltipPosition="top"
                            (click)="agregarUnidadxDia(rowData,0,3)">
                          </button>
                        </div>
                        <div class="col-sm-3 d-flex justify-content-center">
                          <button pButton type="button" icon="pi pi-plus-circle"
                            class="p-button-rounded p-button-text p-button-help" pTooltip="Agregar Especial-Admin"
                            tooltipPosition="top" (click)="agregarUnidadxDia(rowData,1,4)">
                          </button>
                        </div>
                        <div class="col-sm-3 d-flex justify-content-center">
                          <button pButton type="button" icon="pi pi-plus-circle"
                            class="p-button-rounded p-button-text p-button-danger" pTooltip="Agregar Sin Cobro-Admin"
                            tooltipPosition="top" (click)="agregarUnidadxDia(rowData,2,4)">
                          </button>
                        </div>
                        <div class="col-sm-3 d-flex justify-content-center">
                          <button pButton type="button" icon="pi pi-plus-circle"
                            class="p-button-rounded p-button-text p-button-contrast" pTooltip="Agregar Sin Nomina-Admin"
                            tooltipPosition="top" (click)="agregarUnidadxDia(rowData,3,4)">
                          </button>
                        </div>

                      </div>
                    </td> -->
                  </tr>
                </ng-template>
              </p-table>
            </div>
            <div class="row mt-5 mb-5 d-flex justify-content-center">
              <div class="col-6  d-flex justify-content-center">
                <p-colorPicker [(ngModel)]="color_rojo_especial" [disabled]="true"></p-colorPicker>
                <p class="text-left informativo" style="display: inline;">Rutas Especiales</p>
              </div>
            </div>
            <div class="row mt-5 mb-5 d-flex justify-content-center"
              *ngIf="fecha_filtrada<fecha_dia_final&&revPermiteAgregar()">
              <div class="col-6  d-flex justify-content-center">
                <p class="text-left informativo-fechas" style="display: inline;">*No se pueden agregar
                  registros de una Fecha Anterior*</p>
              </div>
            </div>
            <div class="row mt-5 mb-5 d-flex justify-content-center"
              *ngIf="revPermiteAgregar()&&fecha_filtrada>fecha_dia_final">
              <div class="col-6  d-flex justify-content-center">
                <p class="text-left informativo-fechas" style="display: inline;">*No se pueden agregar
                  registros de una Fecha Posterior*</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--AGREGAR UNIDAD DE INFORMACION-->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspEditar" [style]="{width: '80vw','height':'800px'}"
      [transitionOptions]="'0ms'" styleClass="card-shadow">
      <ng-template pTemplate="header">
        <div [ngClass]="{'texto_sm2':true} " class="col-md-2 ">Agregar Servicio</div>

        <div class=" d-flex align-items-center " [ngClass]="{'texto_sm2':true} " *ngIf="dspEditar && clv_especial == 1"
          style="color:red;">
          ESPECIAL
        </div>
        <div [ngClass]="{'texto_sm2':true} " class="d-flex align-items-center"
          *ngIf="dspEditar && this.clv_especial == 2" style="color:#FF8C00">
          SIN&nbsp;COBRO
        </div>
        <div [ngClass]="{'texto_sm2':true} " class="d-flex align-items-center"
          *ngIf="dspEditar && this.clv_especial == 3" style="color:rgb(255, 0, 0);">
          SIN&nbsp;NOMINA
        </div>
        <div [ngClass]="{'texto_sm2':true} " class="d-flex align-items-center "
          *ngIf="dspEditar && this.clv_especial == 4" style="color:#e94c3b">
          AUTORIZACIÓ&nbsp;ESPECIAL
        </div>


        <div [ngClass]="{'texto_sm2':true} " class="ml-3" *ngIf="dspEditar && clv_especial == 0" style="color:black;">
          {{nombre_ruta_Editable }} | {{fecha_dia_editable | date: 'dd/MM/yyyy'}}
        </div>
        <div [ngClass]="{'texto_sm2':true} " class="ml-3 " *ngIf="dspEditar && clv_especial != 0" style="color:black;">
          {{nombre_ruta_Editable }} | {{fecha_dia_editable | date: 'dd/MM/yyyy'}}
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <form [formGroup]="reactiveForm" (ngSubmit)="confirmarInformacionAntesGuardar();">
          <!--TEXTO INFORMATIVO PRINCIPAL-->
          <span class="title-light">Informacion Principal<i class="pl-2 pi pi-cog" style="size: 2rem;"></i>
          </span>
          <div class="form-group row mt-2">
            <!-- primer bloque -->
            <div class="col-md-7">

              <!-- --------itzael id input-------- -->
              <div *ngIf="this.nombre_cliente === 'MELI'">
                <div class="row mt-3 ">
                  <div class="col-md-4 mb-4 d-flex justify-content-end align-items-center">
                    <b>Travel&nbsp;ID </b> <i class="pi pi-map color-icon ml-2 mr-3" style="font-size: 1.5rem"></i>
                  </div>
                  <div class="col-sm-8">
                    <input type="number" formControlName="id_ruta_travel" placeholder="Travel ID*"
                      [style]="{'width':'100%', 'font-weight':'bold' }"  maxlength="8"
                        minlength="7"
                        pattern="^\d{7,8}$" class="form-control">
                    <small class="text-muted ">*ID asignado por el cliente (MELI obligatorio) 7-8 Digitos</small>
                  </div>
                </div>
              </div>

              <div *ngIf="this.nombre_cliente !== 'MELI'">
                <div class="row mt-3">
                  <div class="col-md-4 mb-4 d-flex justify-content-end align-items-center">
                    <b>Travel&nbsp;ID </b> <i class="pi pi-map color-icon ml-2 mr-3" style="font-size: 1.5rem"></i>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" formControlName="id_ruta_travel" placeholder="Travel ID*" class="form-control"
                      [style]="{'width':'100%', 'font-weight':'bold' }"
                      [attr.maxlength]="nombre_cliente === 'MELI' ? 7 : null"
                      [attr.pattern]="nombre_cliente === 'MELI' ? '\\d{7}' : null">
                    <small class="text-muted">*ID asignado por el cliente (MELI obligatorio) 7-8 Digitos</small>
                  </div>
                </div>
              </div>

              <!-- ------------rostering id ---------- -->
              <div *ngIf="this.nombre_cliente === 'MELI'">
                <div class="row mt-3">
                  <div class="col-md-4 mb-4 d-flex justify-content-end align-items-center">
                    <b> Rostering&nbsp;Id</b> <i class="pi pi-hashtag color-icon ml-2 mr-3"
                      style="font-size: 1.5rem"></i>
                  </div>
                  <div class="col-sm-8">
                    <input type="number" formControlName="rostering_id" placeholder="Rostering Id" max="99999999"
                      [style]="{'width':'100%', 'font-weight':'bold' }" pattern="\d{8}" class="form-control">
                    <small class="text-muted">8 Digitos</small>
                  </div>
                </div>
              </div>

              <!-- Unidad -->
              <div class="row mt-2">
                <div class="col-md-4 d-flex justify-content-end align-items-center">
                  <b>Unidad</b><i class="pi pi-truck color-icon mr-3 ml-2" style="font-size: 1.5rem"></i>
                </div>
                <div  [ngClass]="{'col-sm-7': reactiveForm.controls['unidades'].disabled, 'col-sm-8': !reactiveForm.controls['unidades'].disabled}">
                  <p-dropdown [options]="lstUnidadesDisponibles" optionLabel="num_economico" formControlName="unidades"
                    [filter]="true" [filterBy]="'num_economico'" autoWidth="false" [showClear]="true"
                    [style]="{'width':'100%' }" placeholder="Seleccione Unidad*" optionValue="id_unidad_transporte">
                  </p-dropdown>
                  <hr class="my-0">
                </div>
                <div class="col-sm-1">
                  <p *ngIf="reactiveForm.controls['unidades'].disabled">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
            </p></div>
              </div>

              <!-- Chofer -->
              <div class="row mt-3">
                <div class="col-md-4 d-flex justify-content-end align-items-center">
                  <b>Chofer</b> <i class="pi pi-user color-icon ml-2 mr-3" style="font-size: 1.5rem"></i>
                </div>

                <div  [ngClass]="{'col-sm-7': reactiveForm.controls['choferes'].disabled, 'col-sm-8': !reactiveForm.controls['choferes'].disabled}">
                  <p-dropdown [options]="lstChoferesDisponibles" optionLabel="nombre_completo" [filter]="true"
                    [filterBy]="'nombre_completo'" formControlName="choferes" autoWidth="false" [showClear]="true"
                    [style]="{'width':'100%' }" placeholder="Seleccione Chofer*" optionValue="cod_chofer">
                  </p-dropdown>
                  <hr class="my-0">
                </div>
                <div class="col-sm-1">
                  <p *ngIf="reactiveForm.controls['choferes'].disabled">
                    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                  </p>
                </div>
              </div>

              <!-- Aprovechamiento -->
              <div class="row mt-3 mb-3">
                <div class="col-md-4 d-flex justify-content-end align-items-center">
                  <b>Aprovechamiento</b> <i class="pi pi-money-bill color-icon ml-2 mr-3" style="font-size: 1.5rem"></i>
                </div>
                <div class="col-sm-8">
                  <p-dropdown [options]="lstaprovechamiento" optionLabel="nombre"
                    formControlName="id_tipo_aprovechamiento" autoWidth="false" [showClear]="true"
                    [style]="{'width':'100%' }" placeholder="Seleccione el tipo de aprovechamiento*"
                    optionValue="id_tipo_aprovechamiento">
                  </p-dropdown>
                  <hr class="my-0">
                </div>
              </div>



            </div>

            <!-- segundo bloque -->
            <div class="col-md-5">

              <div class="col-sm-2">
                <div style="position: relative; margin-top: 20px; margin-left: 70px; text-align: right;">
                  <div class="border border-secondary p-3 rounded bg-light"
                    style="width: 250px; box-shadow: 0 4px 5px rgba(0, 0, 0, 0.2);">
                    <div class="text-left">
                      <h5>Recursos:</h5>
                    </div>

                    <div class="mb-3">
                      <div class="d-flex align-items-center mb-2">
                        <span class="ml-3"><b>Casetas</b></span>&nbsp;
                        <p-checkbox formControlName="clv_confirma_casetas" [binary]="true" class="ml-6"
                          pTooltip="Confirmación Casetas"></p-checkbox>
                      </div>
                      <div class="d-flex align-items-center mb-2">
                        <span class="ml-3"><b>Combustible</b></span>
                        <p-checkbox formControlName="clv_confirma_combustible" [binary]="true" class="ml-3"
                          pTooltip="Confirmación Combustible"></p-checkbox>
                      </div>
                    </div>
                    <div class="text-left mt-3">
                      <h5>Viaje:</h5>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="ml-3"><b>RT</b></span>
                        <p-checkbox formControlName="clv_tipo_viaje" [binary]="true" class="ml-5"
                          pTooltip="Tipo De Viaje Round Trip(RT)"></p-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>


          <hr class="style-two">
          <!--TEXTO INFORMATIVO ADICONALES-->
          <span class="title-light">Informacion de Colaboradores Adicionales<i class="pl-2 pi pi-cog"
              style="size: 2rem;"></i>
          </span>
          <!--Adicional 1-->
          <div class="form-group row mt-2">
            <div class="col-sm-3 color-font d-flex justify-content-end mt-2">
              Adicional 1 <i class="pi pi-user color-icon  ml-4 mr-5" style="font-size: 1.5rem"></i></div>
            <div class="col-sm-3">
              <p-dropdown [options]="lstpuestos" optionLabel="nombre" formControlName="id_puesto1"
                placeholder="Seleccione Puesto*" autoWidth="false" [style]="{'width':'100%'}" optionValue="id"
                [showClear]="true" tooltip="Puesto" tooltipPosition="right"></p-dropdown>
            </div>
            <div class="col-sm-4">
              <p-dropdown [options]="lstChoferesDisponibles" optionLabel="nombre_completo" [filter]="true"
                [filterBy]="'nombre_completo'" formControlName="cod_adicional1" optionValue="cod_chofer"
                autoWidth="false" [showClear]="true" placeholder="Seleccione Colaborador*" [style]="{'width':'100%'}">
              </p-dropdown>
              <hr class="my-0">
            </div>
            <div class="col-sm-2">
              <div class="flex justify-content-center">

              </div>
            </div>
          </div>
          <!--Adicional 2-->
          <div class="form-group row mt-3">
            <div class="col-sm-3 color-font d-flex justify-content-end mt-2">
              Adicional 2 <i class="pi pi-user color-icon  ml-4 mr-5" style="font-size: 1.5rem"></i>
            </div>
            <div class="col-sm-3">
              <p-dropdown [options]="lstpuestos" optionLabel="nombre" formControlName="id_puesto2"
                placeholder="Seleccione Puesto*" autoWidth="false" [style]="{'width':'100%'}" optionValue="id"
                [showClear]="true" tooltip="Puesto" tooltipPosition="right"></p-dropdown>
            </div>
            <div class="col-sm-4">
              <p-dropdown [options]="lstChoferesDisponibles" optionLabel="nombre_completo" [filter]="true"
                [filterBy]="'nombre_completo'" formControlName="cod_adicional2" optionValue="cod_chofer"
                autoWidth="false" [showClear]="true" placeholder="Seleccione Colaborador*" [style]="{'width':'100%'}">
              </p-dropdown>
              <hr class="my-0">
            </div>
            <div class="col-sm-2">
              <div class="flex justify-content-center">
                <!--<p-checkbox formControlName="clv_retardo2" [binary]="true"
                                    pTooltip="Asistencia Pagada con Retardo"></p-checkbox>-->
              </div>
            </div>
          </div>
          <div class="mt-7 d-flex justify-content-center">
            <button type="submit" class="btn btn-lg btn-primary" [disabled]="!reactiveForm.valid"
              (dblclick)="dbGuardarInformacionConfirmacion()">Aceptar</button>
          </div>
          <div class="mt-5 d-flex justify-content-center">
            <p *ngIf="reactiveForm.controls['unidades'].disabled">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
              Cargando Informacion de Unidades
            </p>
            <p *ngIf="reactiveForm.controls['choferes'].disabled">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
              Cargando Informacion de Choferes
            </p>
          </div>

          <div class="mt-6 d-flex justify-content-center">
            <small style="color: red;">
              Unidades deshabilitadas(O) y Colaboradores(O) en Listado cuentan con Ruta sin Finalizar por Operaciones en
              los ultimos 15 dias a la fecha.
              Verificar el apartado de Comprobación.
            </small>
            <!-- <small  style="display: block;"><b>(A) </b>La unidad no tiene registrado el número de kilómetros para mantenimiento en el catálogo de Listado de Unidades. Abastecimiento.</small>
            <small  style="display: block;"><b>(C)</b> La Ruta no tiene número de kilómetros registrado en el Catálogo de Rutas. Comercial.</small> -->
            <!-- <small  style="display: block;"><b>(*)</b> La unidad sobrepasa el kilometraje programado para su próximo mantenimiento al asignar esta Ruta.</small> -->

          </div>

          <div class=" mt-3 d-flex justify-content-center mb-1">
            <p class="text-left informativo"
              style="display: inline; padding-left: 10px; border-left: 5px solid #2c2b2b; font-weight: normal; font-size: 0.8rem;">
              <small><b>(A) </b>La unidad no tiene registrado el número de kilómetros para mantenimiento en el catálogo
                de Listado de Unidades. Abastecimiento.</small>

            </p>
            <p class="text-left informativo"
              style="display: inline; padding-left: 10px; border-left: 5px solid #2c2b2b; font-weight: normal; font-size: 0.8rem;">
              <small><b>(C)</b> La Ruta no tiene número de kilómetros registrado en el Catálogo de Rutas.
                Comercial.</small>
            </p>
            <p class="text-left informativo"
              style="display: inline; padding-left: 10px; border-left: 5px solid #2c2b2b; font-weight: normal; font-size: 0.8rem;">
              <small><b>(*)</b> La unidad sobrepasa el kilometraje programado para su próximo mantenimiento al asignar
                esta Ruta.</small>
            </p>
          </div>

        </form>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarAgregarUnidadyChofer();"></button>
      </ng-template>

    </p-dialog>


    <!--CONSULTA DE INFORMACION DE UNIDADES ASIGNADAS Y CHOFERES-->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspEditarConsulta"
      [style]="{width: '90vw','height':'650px'}" [transitionOptions]="'0ms'" styleClass="card-shadow">
      <ng-template pTemplate="header">
        Consulta de Información
        <div *ngIf="dspEditarConsulta" style="font-size: 18px;">
          <p style="color:black; display: inline; ">Fecha: {{fecha_dia_editable | date: 'dd/MM/yyyy'}}</p>
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <div class="mt-5">
          <p-table #dt2 [value]="lstOperacionDiariaUnidades" [tableStyle]="{'min-width': '50rem'}"
            styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="550px"
            responsiveLayout="scroll"
            [globalFilterFields]="['num_economico','desc_placaUnidad','nombre_chofer','num_folio']" [paginator]="true"
            [rows]="10" [rowsPerPageOptions]="[10,25,50,100]" [showCurrentPageReport]="true" [resizableColumns]="false"
            currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros" [loading]="loadingEditar"
            sortField="num_economico">
            <ng-template pTemplate="caption">
              <div class="flex flex-row-reverse flex-wrap">
                <span class="p-input-icon-left p-ml-auto">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" size="40" (input)="applyFilterGlobal2($event, 'contains')"
                    placeholder="Buscar Numero Economico,Placa,Folio" />
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="nombre_ruta" style="min-width: 250px; width: 250px;">Ruta<p-sortIcon
                    field="nombre_ruta"></p-sortIcon> </th>
                <th>Aprovechamiento</th>
                <th pSortableColumn="num_economico">#Economico <p-sortIcon field="num_economico"></p-sortIcon> </th>
                <th pSortableColumn="desc_placaUnidad">Placa</th>
                <th pSortableColumn="desc_generales">Datos Generales</th>
                <th pSortableColumn="nombre_conf_unidad">Unidad</th>
                <th>Puesto</th>
                <th pSortableColumn="nombre_chofer" style="min-width: 150px; width: 150px;">Chofer<p-sortIcon
                    field="nombre_chofer"></p-sortIcon> </th>
                <th>Apoyo.Aux</th>
                <th>Estatus</th>
                <th class="text-center">Operaciones</th>

              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-ruta>
              <tr [ngClass]="{'texto_sm':true}">
                <td class="text-justify" style="font-weight: bold; color: #3b9be9;">{{ruta.nombre_ruta}}
                  <p style="display: inline-block; color: #107C10;">
                    {{ ruta.desc_folio}}</p>
                  <p style="display: inline-block; color: #e94c3b;" *ngIf="ruta.clv_especial==1">
                    (ESPECIAL) </p>
                  <p style="display: inline-block; color: rgb(246, 130, 6);" *ngIf="ruta.clv_especial==2">
                    (SIN COBRO) </p>
                  <p style="display: inline-block; color: rgb(246, 130, 6);" *ngIf="ruta.id_ruta_travel != ''">
                    (Id: {{ ruta.id_ruta_travel}})</p>
                  <p style="display: inline-block; color: #8d58f0" *ngIf="ruta.rostering_id != ''">
                    (Rostering ID: {{ ruta.rostering_id}})</p>

                </td>
                <td class=" text-center"><b>
                    {{ruta.tipo_aprovechamiento || 'Sin Información' }}
                    {{ruta.clv_tipo_viaje==1?' (RT)':''}}</b></td>
                <td class=" text-center" style="font-weight: bold; color: #107C10;">
                  {{ruta.num_economico}}
                </td>
                <td>{{ruta.desc_placaUnidad}}</td>
                <td>{{ruta.desc_generales}}</td>
                <td>{{ruta.nombre_conf_unidad}}</td>
                <td class="text-justify" style="font-weight: bold; color: #3b9be9; size: 8px;">
                  <ol>
                    <li>{{ruta.desc_puesto_principal}}</li>
                    <li *ngIf="ruta.id_puesto1!=0">{{ruta.desc_puesto_adicional1}}</li>
                    <li *ngIf="ruta.id_puesto2!=0">{{ruta.desc_puesto_adicional2}}</li>
                  </ol>
                </td>
                <td class="text-justify" style="font-weight: bold; color: orange; font-size: 12px;">
                  <ol>
                    <li>{{ruta.nombre_chofer}}</li>
                    <li *ngIf="ruta.id_puesto1!=0">{{ruta.nombre_completo_adicional1}}</li>
                    <li *ngIf="ruta.id_puesto2!=0">{{ruta.nombre_completo_adicional2}}</li>
                  </ol>
                </td>
                <td class="text-justify" style="font-weight: bold; color: #5F9EA0; font-size: 12px;">
                  <ol>
                    <li>
                      <p *ngIf="ruta.clv_retardo==0">NO</p>
                      <p *ngIf="ruta.clv_retardo==1">SI</p>
                    </li>
                    <li *ngIf="ruta.id_puesto1!=0">
                      <p *ngIf="ruta.clv_retardo1==0">NO</p>
                      <p *ngIf="ruta.clv_retardo1==1">SI</p>
                    </li>
                    <li *ngIf="ruta.id_puesto2!=0">
                      <p *ngIf="ruta.clv_retardo2==0">NO</p>
                      <p *ngIf="ruta.clv_retardo2==1">SI</p>
                    </li>
                  </ol>
                </td>
                <td><b>

                    <div *ngIf="ruta.clv_cancelado==1 " class="text-center" style="color: #8d58f0;">
                      &nbsp;CANCELADA&nbsp;</div>
                    <div *ngIf="ruta.clv_cancelado!=1 && ruta.clv_fin_operacion !=1  " class="text-center"
                      style="color: #3be992;">&nbsp;EN CURSO&nbsp;</div>
                    <div *ngIf="ruta.clv_fin_operacion==1 " class="text-center" style="color: #3b9be9;">&nbsp;FINALIZADO
                      POR OPERACION&nbsp;</div>

                  </b></td>

                <td class="text-center">
                  <div class="d-flex gap-3 justify-content-center align-items-center">
                    <!-- CANCELAR -->
                    <!-- <div *ngIf="ruta.clv_cancelado==1" class="col-lila col-md-auto mt-2">CANCELADA</div> -->

                    <div *ngIf="this.credsOpciones.clv_cancel && ruta.clv_cancelado==0 && clv_pa != 6">
                      <button type="button" class="btn custom-cancelar" (click)="confirmarCancelarRuta(ruta)"
                        pTooltip="Marcar ruta Cancelada">&nbsp;&nbsp;Cancelar&nbsp;&nbsp;<i
                          class="pi pi-times">&nbsp;</i></button>
                    </div>

                    <div *ngIf="this.credsOpciones.clv_cancel && ruta.clv_cancelado==1 && clv_pa != 6">

                      <button icon="pi pi-pencil" class="btn custom-cancelar" (click)="confirmarCancelarRuta(ruta)"
                        pTooltip="Habilitar Ruta">Rehabilitar&nbsp;<i class="pi pi-check"></i></button>
                    </div>

                    <!-- ADMIN -->
                    <div *ngIf="this.credsOpciones.clv_update && clv_pa == 6">
                      <div *ngIf="ruta.clv_cancelado==0">
                        <button type="button" class="btn custom-cancelar" (click)="confirmarCancelarRuta(ruta)"
                          pTooltip="Admin-Marcar ruta Cancelada">&nbsp;&nbsp;Cancelar&nbsp;&nbsp;<i
                            class="pi pi-times">&nbsp;</i></button>
                      </div>
                      <div *ngIf="ruta.clv_cancelado==1">
                        <button class="custom-cancelar" (click)="confirmarCancelarRuta(ruta)"
                          pTooltip="Admin-Habilitar Ruta">Rehabilitar&nbsp;<i class="pi pi-times"></i></button>
                      </div>
                    </div>


                    <!-- EDITAR RUTA -->
                    <div *ngIf="this.credsOpciones.clv_update">
                      <button type="button" class="btn custom-editar" (click)="editarUnidadxDia(ruta)"
                        [disabled]="!this.credsOpciones.clv_update" pTooltip="Edicion de ruta(gerente)">
                        EditarRuta&nbsp;<i class="pi pi-pencil"></i>
                      </button>
                    </div>

                    <!-- ELIMINAR -->
                    <div *ngIf="this.credsOpciones.clv_delete">
                      <button type="button" class="btn custom-delete" (click)="confirmarDesactivar(ruta)"
                        [disabled]="!this.credsOpciones.clv_delete" pTooltip="OPC-Eliminar servicio"
                        tooltipPosition="left">
                        Eliminar&nbsp;<i class="pi pi-trash"></i>
                      </button>
                    </div>

                    <!-- FINALIZAR -->
                    <div *ngIf=" ruta.clv_fin_operacion !=1 ">
                      <button type="button" class="btn custom-finalizar" (click)="finalizaroperacion(ruta, 1,0)"
                        pTooltip="Finalizar por Operaciones" tooltipPosition="top">
                        Finalizar&nbsp;<i class="pi pi-check">&nbsp;</i>
                      </button>
                    </div>

                    <div *ngIf="(this.clv_operacion == 1 ||this.clv_operacion == 3) && ruta.clv_fin_operacion !=  0">
                      <button type="button" class="btn custom-finalizar" (click)="finalizaroperacion(ruta, 2, 1)"
                        pTooltip="Cancelar Finalización de Operaciones" tooltipPosition="top">
                        Reactivar&nbsp;<i class="pi pi-check"></i>
                      </button>
                    </div>

                  </div>
                </td>


              </tr>
            </ng-template>
          </p-table>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarMostrarConsulta()"></button>
      </ng-template>

    </p-dialog>



    <p-dialog [(visible)]="DilogEditar" [resizable]="false" [draggable]="false"
      [style]="{width: '80vw','height':'800px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarAgregarUnidadyChofer()">

      <ng-template pTemplate="header">
        <div [ngClass]="{'texto_sm2':true} ">Editar Servicio</div>

        <div style="color:black;" [ngClass]="{'texto_sm2':true} ">
          {{nombre_ruta_Editable }} | {{fecha_dia_editable | date: 'dd/MM/yyyy'}}
        </div>
      </ng-template>

      <!-- check box recuros  -->
      <ng-template pTemplate="content">
        <form [formGroup]="reactiveForm" (ngSubmit)="confirmarInformacionAntesGuardar();">
          <!--TEXTO INFORMATIVO PRINCIPAL-->
          <span class="title-light">Informacion Principal<i class="pl-2 pi pi-cog" style="size: 2rem;"></i>
          </span>
          <div class="form-group row mt-2">
            <!-- primer bloque -->
            <div class="col-md-7">

              <!-- --------itzael id input---------->
              <div *ngIf="this.nombre_cliente === 'MELI'">
                <div class="row mt-3 ">
                  <div class="col-md-4 mb-4 d-flex justify-content-end align-items-center">
                    <b>Travel&nbsp;ID </b> <i class="pi pi-map color-icon ml-2 mr-3" style="font-size: 1.5rem"></i>
                  </div>
                  <div class="col-sm-8">
                    <input type="number" formControlName="id_ruta_travel" placeholder="Travel ID*"
                      [style]="{'width':'100%', 'font-weight':'bold' }"  maxlength="8"
                      minlength="7"
                      pattern="^\d{7,8}$" class="form-control">
                    <small class="text-muted">*ID asignado por el cliente (MELI obligatorio) 7-8 Digitos</small>
                  </div>
                </div>
              </div>
              <!-- <div *ngIf="this.nombre_cliente === 'MELI'">
                <div class="row">
                  <div class="col-md-4" style="text-align: center; margin-top: 5px;">
                    <label class="col-sm-3 col-form-label color-font text-center">
                      <span class="input-group-addon">
                        <i class="pi pi-map color-icon mr-3" style="font-size: 2rem"></i>
                      </span>
                      Travel&nbsp;ID
                    </label>
                  </div>
                  <div class="col-sm-8">
                    <input type="number" formControlName="id_ruta_travel" placeholder="Travel ID*" max="9999999"
                      pattern="\d{7}" class="form-control"
                      [style]="{'width':'100%' , 'margin-top': '20px' , 'font-weight':'bold' }">


                    <small class="text-muted">*ID asignado por el cliente (MELI obligatorio) 7 Digitos</small>
                  </div>
                </div>
              </div> -->

              <div *ngIf="this.nombre_cliente !== 'MELI'">
                <div class="row mt-3">
                  <div class="col-md-4 mb-4 d-flex justify-content-end align-items-center">
                    <b>Travel&nbsp;ID </b> <i class="pi pi-map color-icon ml-2 mr-3" style="font-size: 1.5rem"></i>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" formControlName="id_ruta_travel" placeholder="Travel ID*" class="form-control"
                      [style]="{'width':'100%', 'font-weight':'bold' }"
                      [attr.maxlength]="nombre_cliente === 'MELI' ? 7 : null"
                      [attr.pattern]="nombre_cliente === 'MELI' ? '\\d{7}' : null">
                    <small class="text-muted">*ID asignado por el cliente (MELI obligatorio) 7-8 Digitos</small>
                  </div>
                </div>
              </div>

              <!-- ------------rostering id ---------- -->
              <div *ngIf="this.nombre_cliente === 'MELI'">
                <div class="row mt-3">
                  <div class="col-md-4 mb-4 d-flex justify-content-end align-items-center">
                    <b> Rostering&nbsp;Id</b> <i class="pi pi-hashtag color-icon ml-2 mr-3"
                      style="font-size: 1.5rem"></i>
                  </div>
                  <div class="col-sm-8">
                    <input type="number" formControlName="rostering_id" placeholder="Rostering Id" max="99999999"
                      [style]="{'width':'100%', 'font-weight':'bold' }" pattern="\d{8}" class="form-control">
                    <small class="text-muted">8 Digitos</small>
                  </div>
                </div>
              </div>

              <!-- Unidad -->
              <div class="row mt-2">
                <div class="col-md-4 d-flex justify-content-end align-items-center">
                  <b>Unidad</b><i class="pi pi-truck color-icon mr-3 ml-2" style="font-size: 1.5rem"></i>
                </div>
                <div class="col-sm-8">
                  <p-dropdown [options]="lstUnidadesDisponibles" optionLabel="num_economico" formControlName="unidades"
                    [filter]="true" [filterBy]="'num_economico'" autoWidth="false" [showClear]="true"
                    [style]="{'width':'100%' }" placeholder="Seleccione Unidad*" optionValue="id_unidad_transporte">
                  </p-dropdown>
                  <hr class="my-0">
                </div>
              </div>

              <!-- Chofer -->
              <div class="row mt-3">
                <div class="col-md-4 d-flex justify-content-end align-items-center">
                  <b>Chofer</b> <i class="pi pi-user color-icon ml-2 mr-3" style="font-size: 1.5rem"></i>
                </div>
                <div class="col-sm-8">
                  <p-dropdown [options]="lstChoferesDisponibles" optionLabel="nombre_completo" [filter]="true"
                    [filterBy]="'nombre_completo'" formControlName="choferes" autoWidth="false" [showClear]="true"
                    [style]="{'width':'100%' }" placeholder="Seleccione Chofer*" optionValue="cod_chofer">
                  </p-dropdown>
                  <hr class="my-0">
                </div>
              </div>

              <!-- Aprovechamiento -->
              <div class="row mt-3 mb-3">
                <div class="col-md-4 d-flex justify-content-end align-items-center">
                  <b>Aprovechamiento</b> <i class="pi pi-money-bill color-icon ml-2 mr-3" style="font-size: 1.5rem"></i>
                </div>
                <div class="col-sm-8">
                  <p-dropdown [options]="lstaprovechamiento" optionLabel="nombre"
                    formControlName="id_tipo_aprovechamiento" autoWidth="false" [showClear]="true"
                    [style]="{'width':'100%' }" placeholder="Seleccione el tipo de aprovechamiento*"
                    optionValue="id_tipo_aprovechamiento">
                  </p-dropdown>
                  <hr class="my-0">
                </div>
              </div>


            </div>

            <!-- segundo bloque -->
            <div class="col-md-5">

              <div class="col-sm-2">
                <div style="position: relative; margin-top: 20px; margin-left: 70px; text-align: right;">
                  <div class="border border-secondary p-3 rounded bg-light"
                    style="width: 250px; box-shadow: 0 4px 5px rgba(0, 0, 0, 0.2);">
                    <div class="text-left">
                      <h5>Recursos:</h5>
                    </div>

                    <div class="mb-3">
                      <div class="d-flex align-items-center mb-2">
                        <span class="ml-3"><b>Casetas</b></span>&nbsp;
                        <p-checkbox formControlName="clv_confirma_casetas" [binary]="true" class="ml-6"
                          pTooltip="Confirmación Casetas"></p-checkbox>
                      </div>
                      <div class="d-flex align-items-center mb-2">
                        <span class="ml-3"><b>Combustible</b></span>
                        <p-checkbox formControlName="clv_confirma_combustible" [binary]="true" class="ml-3"
                          pTooltip="Confirmación Combustible"></p-checkbox>
                      </div>
                    </div>
                    <div class="text-left mt-3">
                      <h5>Viaje:</h5>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="ml-3"><b>RT</b></span>
                        <p-checkbox formControlName="clv_tipo_viaje" [binary]="true" class="ml-5"
                          pTooltip="Tipo De Viaje Round Trip(RT)"></p-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>




          <hr class="style-two">
          <!--TEXTO INFORMATIVO ADICONALES-->
          <span class="title-light">Informacion de Colaboradores Adicionales<i class="pl-2 pi pi-cog"
              style="size: 2rem;"></i>
          </span>
          <!--Adicional 1-->
          <div class="form-group row mt-2">
            <div class="col-sm-3 color-font d-flex justify-content-end mt-2">
              Adicional 1 <i class="pi pi-user color-icon  ml-4 mr-5" style="font-size: 1.5rem"></i>
            </div>
            <div class="col-sm-3">
              <p-dropdown [options]="lstpuestos" optionLabel="nombre" formControlName="id_puesto1"
                placeholder="Seleccione Puesto*" autoWidth="false" [style]="{'width':'100%'}" optionValue="id"
                [showClear]="true" tooltip="Puesto" tooltipPosition="right"></p-dropdown>
            </div>
            <div class="col-sm-4">
              <p-dropdown [options]="lstChoferesDisponibles" optionLabel="nombre_completo" [filter]="true"
                [filterBy]="'nombre_completo'" formControlName="cod_adicional1" optionValue="cod_chofer"
                autoWidth="false" [showClear]="true" placeholder="Seleccione Colaborador*" [style]="{'width':'100%'}">
              </p-dropdown>
              <hr class="my-0">
            </div>
            <div class="col-sm-2">
              <div class="flex justify-content-center">
                <!--<p-checkbox formControlName="clv_retardo1" [binary]="true"
                                      pTooltip="Asistencia Pagada con Retardo"></p-checkbox>-->
              </div>
            </div>
          </div>
          <!--Adicional 2-->
          <div class="form-group row mt-3">
            <div class="col-sm-3 color-font d-flex justify-content-end mt-2">
              Adicional 2 <i class="pi pi-user color-icon  ml-4 mr-5" style="font-size: 1.5rem"></i>
            </div>
            <div class="col-sm-3">
              <p-dropdown [options]="lstpuestos" optionLabel="nombre" formControlName="id_puesto2"
                placeholder="Seleccione Puesto*" autoWidth="false" [style]="{'width':'100%'}" optionValue="id"
                [showClear]="true" tooltip="Puesto" tooltipPosition="right"></p-dropdown>
            </div>
            <div class="col-sm-4">
              <p-dropdown [options]="lstChoferesDisponibles" optionLabel="nombre_completo" [filter]="true"
                [filterBy]="'nombre_completo'" formControlName="cod_adicional2" optionValue="cod_chofer"
                autoWidth="false" [showClear]="true" placeholder="Seleccione Colaborador*" [style]="{'width':'100%'}">
              </p-dropdown>
              <hr class="my-0">
            </div>
            <div class="col-sm-2">
              <div class="flex justify-content-center">
                <!--<p-checkbox formControlName="clv_retardo2" [binary]="true"
                                      pTooltip="Asistencia Pagada con Retardo"></p-checkbox>-->
              </div>
            </div>
          </div>
          <div class="mt-5 d-flex justify-content-center">
            <button type="submit" class="btn btn-lg btn-primary" [disabled]="!reactiveForm.valid"
              (dblclick)="dbGuardarInformacionConfirmacion()">Aceptar</button>
          </div>
          <div class="mt-5 d-flex justify-content-center">
            <p *ngIf="reactiveForm.controls['unidades'].disabled">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
              Cargando Informacion de Unidades
            </p>
            <p *ngIf="reactiveForm.controls['choferes'].disabled">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
              Cargando Informacion de Choferes
            </p>
          </div>
          <div class="mt-5 d-flex justify-content-center">
            <small style="color: red;">
              Unidades deshabilitadas en Listado cuentan con Ruta sin Finalizar Combustible.
              Verificar con el area de Mesa de Recursos.
            </small>
            <!-- <small  style="display: block;"><b>(A) </b>La unidad no tiene registrado el número de kilómetros para mantenimiento en el catálogo de Listado de Unidades. Abastecimiento.</small>
            <small  style="display: block;"><b>(C)</b> La Ruta no tiene número de kilómetros registrado en el Catálogo de Rutas. Comercial.</small> -->
            <!-- <small  style="display: block;"><b>(*)</b> La unidad sobrepasa el kilometraje programado para su próximo mantenimiento al asignar esta Ruta.</small> -->

          </div>

          <div class=" mt-3 d-flex justify-content-center">
            <p class="text-left informativo"
              style="display: inline; padding-left: 10px; border-left: 5px solid #2c2b2b; font-weight: normal; font-size: 0.8rem;">
              <small><b>(A) </b>La unidad no tiene registrado el número de kilómetros para mantenimiento en el catálogo
                de Listado de Unidades. Abastecimiento.</small>

            </p>
            <p class="text-left informativo"
              style="display: inline; padding-left: 10px; border-left: 5px solid #2c2b2b; font-weight: normal; font-size: 0.8rem;">
              <small><b>(C)</b> La Ruta no tiene número de kilómetros registrado en el Catálogo de Rutas.
                Comercial.</small>
            </p>
            <p class="text-left informativo"
              style="display: inline; padding-left: 10px; border-left: 5px solid #2c2b2b; font-weight: normal; font-size: 0.8rem;">
              <small><b>(*)</b> La unidad sobrepasa el kilometraje programado para su próximo mantenimiento al asignar
                esta Ruta.</small>
            </p>
          </div>
        </form>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarAgregarUnidadyChofer();"></button>
      </ng-template>
    </p-dialog>




    <!--Confirmar Asignacion de Unidades-->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspConfirmarAsignacion"
      [style]="{width: '60vw','height':'550px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarMostrarConfirmacion()">
      <ng-template pTemplate="header">
        Confirmación de Guardado
      </ng-template>
      <ng-template pTemplate="content">
        <div class="mt-5">
          <div class="card-content card-shadow sinborde">
            <div class="row d-flex justify-content-center">
              <div class="col-10">
                <h3 class="text-center">¿Estas Seguro que deseas guardar la Informacion?</h3>
                <table class="table mt-5">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">Numero Economico</th>
                      <th scope="col">Nombre de Chofer</th>
                      <th scope="col">Puesto</th>
                      <th scope="col">Apoyo de Auxiliar</th>
                      <th scope="col">Aprovechamiento</th>
                      <th scope="col">Ruta</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of lstConfirmacionColaboradores">
                      <td class="col-blue">{{data.num_economico}}</td>
                      <td class="texto_sm1 text-center">{{data.nombre_completo}}
                      </td>
                      <td class="col-blue text-center">{{data.desc_puesto}}</td>
                      <td class="col-blue text-center">{{data.clv_retardo}}</td>
                      <td class="col-blue text-center">{{data.aprovechamiento || 'Sin Información' }}</td>
                      <td class="col-blue">{{ data.desc_ruta}}
                        <div style="color:red;">
                          <p *ngIf="clv_especial==1">(ESPECIAL)</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-warning"
          (click)="cancelarMostrarConfirmacion()"></button>
        <button (click)="guardarUnidadaRutaxDia()" pButton icon="pi pi-check" label="Aceptar" class="p-button-success"
          (dblclick)="dbGuardarInformacionConfirmacion()" [disabled]="desactivarBotonGuardar"></button>
      </ng-template>
    </p-dialog>


    <!-- ---------Asignar Servicios Sin Ruta--------------------- -->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspsinruta"
      [style]="{width: '85vw','height':'800px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarsinruta()">
      <ng-template pTemplate="header">
        Gestión de servicios sin ruta
      </ng-template>

      <ng-template pTemplate="content">
        <div class="row mt-1 d-flex justify-content-start">
          <div class="col-sm-6">
            <span class="title-light">Filtre para obtener los Servicios Sin Ruta
              <i class="pi pi-cog" style="size: 2rem;">
              </i>
            </span>
          </div>
        </div>

        <div class="mt-4 d-flex justify-content-around">
          <div class="col-md-6 row">
            <div class="col-md-4">
              <label for="lblligero" class="col-form-label color-font text-right"
                style="font-weight: 600; font-family: 'Poppins', sans-serif;">
                <span class="input-group-addon"> <i class="pi pi-calendar color-icon mr-3"
                    style="font-size: 2rem; color: #3B82F6;"></i>
                </span>
                Fecha
              </label>
            </div>
            <div class="col-md-8 mt-2">
              <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha"
                tooltipPosition="top" [(ngModel)]="fecha_fil_sin_reg" (ngModelChange)="limpiarlista()">
              <hr class="my-1">
            </div>
          </div>


          <div class="col-md-2 ml-3 mt-1">
            <button type="button" class="custom-out" style="width: 100%;" (click)="getserviciossinruta()"><i
                class="pi pi-filter"></i>
              Filtrar
            </button>
          </div>
          <div class="col-md-2 ml-3 mt-1">
            <button
              [disabled]="
            habilitaragregar ||
            (clv_operacion == 0 && fecha_fil_sin_reg < fecha_dia_final  || (clv_operacion_sinruta ==1 && clv_operacion == 0 )) "
              type="button" class="custom-sinout" style="width: 100%;" (click)="addserviciossinruta()">
              <i class="pi pi-plus"></i>&nbsp;Registrar
            </button>

          </div>


        </div>
        <hr class="style-two">

        <!-- Tabla con los resultados-->
        <div class="mt-5 ">
          <div class="row d-flex justify-content-center">
            <div class="col-md-3"></div>
            <div class="col-6 text-center">
              <h5 class="texto-pesado" style="color:#3b9be9"><b>Listado de Servicios Sin Ruta</b></h5>
            </div>

            <div class="col-md-3 d-flex justify-content-end mb-2">
              <span class="p-input-icon-left p-ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text" size="35" (input)="applyFilterGlobal2($event, 'contains')"
                  placeholder="Buscar" tooltipPosition="top" class="form-control"
                  pTooltip="Buscar por numero económico, ciudad, folio o chofer" />
              </span>
            </div>
          </div>
          <p-table #dt2 [value]="lstsinServicio" [tableStyle]="{'min-width': '50rem'}" styleClass="p-datatable-sm"
            [scrollable]="true" scrollHeight="320px" responsiveLayout="scroll" [paginator]="true" [rows]="50"
            [rowsPerPageOptions]="[25,50,75,100,150]" [showCurrentPageReport]="true" [resizableColumns]="false"
            [globalFilterFields]="['num_economico','desc_ciudad','choferes_con_puestos', 'folio_serviciosinruta', 'id_ruta_travel']"
            currentPageReportTemplate="{first} a {last} de {totalRecords} Registros" [loading]="loading_sin">

            <ng-template pTemplate="header">
              <tr>
                <th class="text-center">Ciudad</th>
                <th class="text-center">Folio</th>
                <th class="text-center">Travel ID</th>
                <th class="text-center">Rostering ID</th>
                <th class="text-center">Número económico</th>
                <th class="text-center" style="min-width: 200px; width: 200;">Puesto(s), colaborador(es)</th>
                <th class="text-center">Operaciones</th>
                <th class="text-center" *ngIf="clv_operacion != 0">Eliminar</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-fol>
              <tr>
                <td class="text-center" style="color: #1e5a9c;"><b>{{fol.desc_ciudad_hm}}</b></td>
                <td class="text-center" style="color: #4CAF50FF;"><b>{{fol.folio_serviciosinruta}}</b></td>
                <td class="text-center"><b>{{fol.id_ruta_travel}}</b></td>
                <td class="text-center"><b>{{fol.rostering_id}}</b></td>
                <td class="text-center">{{fol.num_economico}}</td>
                <td class="text-center" style="min-width: 230px; width: 250;">{{fol.choferes_con_puestos}}</td>
                <td class="text-center">

                  <button icon="pi pi-plus" class="custom-buttoncargar1" pButton pRipple type="button"
                    (click)="habiliatragregarruta(fol);" label="Asignar&nbsp;Ruta" iconPos="left"
                    [disabled]="habilitaragregar ||
                              (clv_operacion == 0 && fecha_fil_sin_reg < fecha_dia_final || (clv_operacion_sinruta == 1 && clv_operacion == 0))">
                  </button>
                </td>
                <td *ngIf="clv_operacion != 0" class="text-center"> <button icon="pi pi-trash" class="custom-elim"
                    pButton pRipple type="button" (click)="eliminarmovsin(fol);" label="Eliminar" iconPos="left"
                    [disabled]="habilitaragregar ||
                 (clv_operacion == 0 && fecha_fil_sin_reg < fecha_dia_final || (clv_operacion_sinruta == 1 && clv_operacion == 0))">
                  </button></td>
              </tr>
            </ng-template>
          </p-table>
          <div class="row mt-5 d-flex justify-content-start">
            <small>
              <em>*Servicios en el listado estan pendientes de asignar Ruta.</em>
            </small>
          </div>
          <div class="row d-flex justify-content-start">
            <small>
              <em>*El botón "Registrar(+)" se deshabilita si existen servicios menor a la fecha sin Asignar Ruta y el
                usuario no cuenta con permisos.</em>
            </small>
          </div>

        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarsinruta();"></button>
      </ng-template>
    </p-dialog>




    <!-- agregar servicio sin ruta -->
    <p-dialog [(visible)]="Dspaddsinruta" [resizable]="false" [draggable]="false"
      [style]="{width: '75vw','height':'630px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarserviciossinruta()">
      <ng-template pTemplate="header">
        Agregar Servicio Sin Ruta
        <div style="color:black;">
        </div>
      </ng-template>

      <!-- check box recuros  -->
      <ng-template pTemplate="content">
        <form [formGroup]="sinservicioForm" (ngSubmit)="guardarUnidadadsinruta();">
          <span class="title-light">Informacion Principal<i class="pl-2 pi pi-cog" style="size: 2rem;"></i>
          </span>
          <div class="form-group row mt-2">
            <div class="col-md-8">
              <div class="row">
                <div class="col-md-4 d-flex align-items-center" style="text-align: left;">
                  <small class="col-sm-3 col-form-label color-font d-flex align-items-center">
                    <i class="pi pi-user color-icon ml-3 mr-2" style="font-size: 1.5rem;"></i>
                    Fecha</small>
                </div>
                <div class="col-md-8">
                  <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha"
                    tooltipPosition="top" formControlName="fecha_fil_sin_reg">
                  <hr class="my-1">
                </div>
              </div>
              <div class=" row">
                <div class="col-md-4 d-flex align-items-center" style="text-align: left;">
                  <small class="col-sm-3 col-form-label color-font d-flex align-items-center">
                    <i class="pi pi-user color-icon ml-3 mr-2" style="font-size: 1.5rem;"></i>
                    Ciudad</small>
                </div>
                <div class="col-md-8 mt-2">
                  <p-dropdown [options]="lstCiudades" autoWidth="false" [style]="{'width':'100%'}"
                    placeholder="Seleccione Ciudad*" formControlName="id_ciudad_hm" optionLabel="nombre"
                    [showClear]="true" optionValue="id"></p-dropdown>

                  <hr class="my-1">
                </div>
              </div>
              <!-- Travel ID -->
              <div class="row">
                <div class="col-md-4 d-flex align-items-center" style="text-align: left;">
                  <small class="col-sm col-form-label color-font d-flex align-items-center">
                    <i class="pi pi-map color-icon ml-3 mr-2" style="font-size: 1.5rem;"></i>
                    Travel ID
                  </small>
                </div>
                <div class="col-sm-8 mt-2">
                  <input type="text" formControlName="id_ruta_travel" [value]="id_ruta_travel" placeholder="Travel ID*"
                    class="form-control" [style]="{'width':'100%' , 'font-weight':'bold' }">
                  <small class="text-muted"> 7-8 Digitos</small>
                </div>
              </div>
              <!-- Rostering Id -->
              <div class="row">
                <div class="col-md-4 d-flex align-items-center" style="text-align: left;">
                  <small class="col-sm col-form-label color-font d-flex align-items-center">
                    <i class="pi pi-hashtag color-icon ml-3 mr-2" style="font-size: 1.5rem;"></i>
                    Rostering&nbsp;Id
                  </small>
                </div>
                <div class="col-sm-8 mt-2">
                  <input type="text" formControlName="rostering_id" [value]="id_ruta_travel" placeholder="Rostering Id*"
                    class="form-control" [style]="{'width':'100%' , 'font-weight':'bold' }">
                  <small class="text-muted">8 Digitos</small>
                </div>
              </div>
              <!-- Unidad -->
              <div class="row">
                <div class="col-md-4 d-flex align-items-center" style="text-align: left;">
                  <small class="col-sm-3 col-form-label color-font d-flex align-items-center">
                    <i class="pi pi-truck color-icon ml-3 mr-2" style="font-size: 1.5rem;"></i>
                    Unidad
                  </small>
                </div>
                <div class="col-sm-8 mt-2">
                  <p-dropdown [options]="lstUnidadesDisponibles" optionLabel="num_economico"
                    formControlName="id_unidad_transporte" autoWidth="false" [showClear]="true"
                    placeholder="Seleccione Unidad*" [style]="{'width':'100%' }" optionValue="id_unidad_transporte">
                  </p-dropdown>
                  <hr class="my-0">
                </div>
              </div>

              <!-- Chofer -->
              <div class="row">
                <div class="col-md-4 d-flex align-items-center" style="text-align: left;">
                  <small class="col-sm-3 col-form-label color-font d-flex align-items-center">
                    <i class="pi pi-user color-icon ml-3 mr-2" style="font-size: 1.5rem;"></i>
                    <!-- Agregado ml-3 para mayor margen a la izquierda -->
                    Chofer
                  </small>
                </div>
                <div class="col-sm-8 mt-2">
                  <p-dropdown [options]="lstChoferesDisponibles" optionLabel="nombre_completo" [filter]="true"
                    [filterBy]="'nombre_completo'" formControlName="cod_chofer" autoWidth="false" [showClear]="true"
                    placeholder="Seleccione Chofer*" [style]="{'width':'100%' }" optionValue="cod_chofer">
                  </p-dropdown>
                  <hr class="my-0">
                </div>
              </div>

              <!-- Aprovechamiento -->
              <div class="row">
                <div class="col-md-4 d-flex align-items-center" style="text-align: left;">
                  <small class="col-sm-3 col-form-label color-font d-flex align-items-center">
                    <i class="pi pi-money-bill color-icon ml-3 mr-2" style="font-size: 1.5rem;"></i>
                    <!-- Agregado ml-3 para mayor margen a la izquierda -->
                    Aprovechamiento
                  </small>
                </div>
                <div class="col-sm-8 mt-2">
                  <p-dropdown [options]="lstaprovechamiento" optionLabel="nombre"
                    formControlName="id_tipo_aprovechamiento" autoWidth="false" [showClear]="true"
                    placeholder="Seleccione el tipo de aprovechamiento*" [style]="{'width':'100%' }"
                    optionValue="id_tipo_aprovechamiento">
                  </p-dropdown>
                  <hr class="my-0">
                </div>
              </div>
            </div>

            <!-- Segundo bloque -->
            <div class="col-md-4">
              <div class="col-sm-2">
                <div style="position: relative; margin-top: 20px; margin-left: 70px; text-align: right;">
                  <div class="border border-secondary p-3 rounded bg-light"
                    style="width: 200px; box-shadow: 0 4px 5px rgba(0, 0, 0, 0.2);">
                    <!-- <div class="text-left">
                      <h5>Recursos:</h5>
                    </div>
                    <div class="mb-3">
                      <div class="d-flex align-items-center mb-2">
                        <span class="ml-3"><b>Casetas</b></span>&nbsp;
                        <p-checkbox formControlName="clv_confirma_casetas" [binary]="true" class="ml-6"
                          pTooltip="Confirmación Casetas"></p-checkbox>
                      </div>
                      <div class="d-flex align-items-center mb-2">
                        <span class="ml-3"><b>Combustible</b></span>
                        <p-checkbox formControlName="clv_confirma_combustible" [binary]="true" class="ml-3"
                          pTooltip="Confirmación Combustible"></p-checkbox>
                      </div>
                    </div> -->
                    <div class="text-left ">
                      <h5>Viaje:</h5>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="ml-3"><b>RT</b></span>
                        <p-checkbox formControlName="clv_tipo_viaje" [binary]="true" class="ml-5"
                          pTooltip="Tipo De Viaje Round Trip(RT)"></p-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr class="style-two">
          <!--TEXTO INFORMATIVO ADICONALES-->
          <span class="title-light">Informacion de Colaboradores Adicionales<i class="pl-2 pi pi-cog"
              style="size: 1.5rem;"></i>
          </span>
          <!--Adicional 1-->
          <div class="form-group row mt-2">
            <label for="lblligero" class="col-sm-3 col-form-label color-font text-center">
              <span class="input-group-addon"> <i class="pi pi-user color-icon mr-3" style="font-size: 1.5rem"></i>
              </span>
              Adicional 1</label>
            <div class="col-sm-3">
              <p-dropdown [options]="lstpuestos" optionLabel="nombre" formControlName="id_puesto1"
                placeholder="Seleccione Puesto*" autoWidth="false" [style]="{'width':'100%'}" optionValue="id"
                [showClear]="true" tooltip="Puesto" tooltipPosition="right"></p-dropdown>
            </div>
            <div class="col-sm-4">
              <p-dropdown [options]="lstChoferesDisponibles" optionLabel="nombre_completo" [filter]="true"
                [filterBy]="'nombre_completo'" formControlName="cod_adicional1" optionValue="cod_chofer"
                autoWidth="false" [showClear]="true" placeholder="Seleccione Colaborador*" [style]="{'width':'100%'}">
              </p-dropdown>
              <hr class="my-0">
            </div>
            <div class="col-sm-2">
              <div class="flex justify-content-center">
              </div>
            </div>
          </div>



          <div class="form-group row mt-3">
            <label for="lblligero" class="col-sm-3 col-form-label color-font text-center">
              <span class="input-group-addon"> <i class="pi pi-user color-icon mr-3" style="font-size: 1.5rem"></i>
              </span>
              Adicional 2</label>
            <div class="col-sm-3">
              <p-dropdown [options]="lstpuestos" optionLabel="nombre" formControlName="id_puesto2"
                placeholder="Seleccione Puesto*" autoWidth="false" [style]="{'width':'100%'}" optionValue="id"
                [showClear]="true" tooltip="Puesto" tooltipPosition="right"></p-dropdown>
            </div>
            <div class="col-sm-4">
              <p-dropdown [options]="lstChoferesDisponibles" optionLabel="nombre_completo" [filter]="true"
                [filterBy]="'nombre_completo'" formControlName="cod_adicional2" optionValue="cod_chofer"
                autoWidth="false" [showClear]="true" placeholder="Seleccione Colaborador*" [style]="{'width':'100%'}">
              </p-dropdown>
              <hr class="my-0">
            </div>
            <div class="col-sm-2">
              <div class="flex justify-content-center">

              </div>
            </div>
          </div>
          <div class="mt-5 d-flex justify-content-center">
            <button type="submit" class="btn btn-lg btn-primary" [disabled]="!sinservicioForm.valid"
              (dblclick)="guardarUnidadadsinruta()">Aceptar</button>
          </div>
          <div class="mt-5 d-flex justify-content-center">
            <p *ngIf="reactiveForm.controls['unidades'].disabled">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
              Cargando Informacion de Unidades
            </p>
            <p *ngIf="reactiveForm.controls['choferes'].disabled">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
              Cargando Informacion de Choferes
            </p>
          </div>
          <div class="mt-5 d-flex justify-content-center">
            <small style="color: red;">
              Unidades deshabilitadas en Listado cuentan con Ruta sin Finalizar Combustible.
              Verificar con el area de Mesa de Recursos.
            </small>
          </div>

          <div class=" mt-3 d-flex justify-content-center">
            <p class="text-left informativo"
              style="display: inline; padding-left: 10px; border-left: 5px solid #2c2b2b; font-weight: normal; font-size: 0.8rem;">
              <small><b>(A) </b>La unidad no tiene registrado el número de kilómetros para mantenimiento en el catálogo
                de Listado de Unidades. Abastecimiento.</small>

            </p>
            <!-- <p class="text-left informativo"
            style="display: inline; padding-left: 10px; border-left: 5px solid #2c2b2b; font-weight: normal; font-size: 0.8rem;">
            <small><b>(C)</b> La Ruta no tiene número de kilómetros registrado en el Catálogo de Rutas.
              Comercial.</small>
          </p> -->
            <p class="text-left informativo"
              style="display: inline; padding-left: 10px; border-left: 5px solid #2c2b2b; font-weight: normal; font-size: 0.8rem;">
              <small><b>(*)</b> La unidad sobrepasa el kilometraje programado para su próximo mantenimiento al asignar
                esta Ruta.</small>
            </p>
          </div>
        </form>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarserviciossinruta();"></button>
      </ng-template>
    </p-dialog>




    <!-- ------------------AGREGAR RUTA A SERVICIO SIN RUTA------------------ -->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspagregarruta"
      [style]="{width: '65vw','height':'600px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarhabiliatragregarruta()">
      <ng-template pTemplate="header">
        Asignar Ruta a Folio
      </ng-template>

      <ng-template pTemplate="content">



        <div class="row d-flex justify-content-center mt-5 mb-2">
          <div class="col-md-3"></div>
          <div class="col-6 text-center">
            <h5 class="texto-pesado" style="color:#3b9be9"><b>Listado de Rutas</b></h5>
          </div>

          <div class="col-md-3 d-flex justify-content-end">
            <span class="p-input-icon-left p-ml-auto">
              <i class="pi pi-search"></i>
              <input pInputText type="text" size="35" (input)="applyFilterGlobal3($event, 'contains')"
                placeholder="Buscar por ruta" tooltipPosition="top" class="form-control" />
            </span>
          </div>
        </div>


        <p-table #dt3 [value]="lstOperacionDiariaReal_sinruta" [tableStyle]="{'min-width': '50rem'}"
          styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="320px" responsiveLayout="scroll"
          [paginator]="true" [rows]="50" [rowsPerPageOptions]="[25,50,75,100,150]" [showCurrentPageReport]="true"
          [resizableColumns]="false" [globalFilterFields]="['nombre_ruta','nombre_ciudad']"
          currentPageReportTemplate="{first} a {last} de {totalRecords} Registros" [loading]="loading_sin_rut">


          <ng-template pTemplate="header">
            <tr>
              <th class="text-center" pSortableColumn="desc_placaUnidad">Ciudad<p-sortIcon
                  field="desc_placaUnidad"></p-sortIcon></th>
              <th class="text-center " style="min-width: 270px; width: 270px;" pSortableColumn="desc_trasporte">
                Ruta<p-sortIcon field="desc_trasporte"></p-sortIcon></th>
              <th pSortableColumn="desc_estatus">Operaciones<p-sortIcon field="desc_estatus"></p-sortIcon></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-fol>
            <tr>
              <td class="text-center" style="color: #1e5a9c;"><b>{{fol.nombre_ciudad}}</b></td>
              <td style="min-width: 270px; width: 270px;" class="text-center">{{fol.nombre_ruta}}</td>
              <td>
                <button class="custom-agg" pButton pRipple type="button" (click)="guardaragregarruta(fol);"
                  label="Asignar Ruta" icon="pi pi-check" iconPos="left"></button>
              </td>


            </tr>
          </ng-template>
        </p-table>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarhabiliatragregarruta();"></button>
      </ng-template>
    </p-dialog>





    <!-- ---------Consultar Criterio-------------------- -->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspcriterio"
      [style]="{width: '90vw','height':'850px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarCriterio()">
      <ng-template pTemplate="header">
        Consulta de Criterio
      </ng-template>

      <ng-template pTemplate="content">

        <div class="row mt-1 d-flex justify-content-start">
          <div class="col-sm-7">
            <span class="title-light2">Filtre para consultar el criterio de asiganción de ruta
              <i class="pi pi-cog" style="size: 2rem;">
              </i>
            </span>
          </div>
        </div>
        <form [formGroup]="criterioForm">


          <div class="mt-4 d-flex justify-content-around">

            <div class="col-md-3 row">
              <div class="col-md-4">
                <label for="lblligero" class="col-form-label color-font text-right"
                  style="font-weight: 600; font-family: 'Poppins', sans-serif;">
                  <span class="input-group-addon"> <i class="pi pi-map color-icon mr-3"
                      style="font-size: 2rem; color: #3B82F6;"></i>
                  </span>
                  Ciudad
                </label>
              </div>
              <div class="col-md-8 mt-1">

                <p-dropdown [options]="lstCiudadescriterio" autoWidth="false" [style]="{'width':'100%'}"
                  placeholder="Seleccione Ciudad*" formControlName="id_ciudad_hm" optionLabel="nombre"
                  [showClear]="true" optionValue="id"></p-dropdown>
                <hr class="my-1">

              </div>
            </div>

            <div class="col-md-3 row">
              <div class="col-md-4">
                <label for="lblligero" class="col-form-label color-font text-right"
                  style="font-weight: 600; font-family: 'Poppins', sans-serif;">
                  <span class="input-group-addon"> <i class="pi pi-calendar color-icon mr-3"
                      style="font-size: 2rem; color: #3B82F6;"></i>
                  </span>
                  Fecha
                </label>
              </div>
              <div class="col-md-8 mt-2">
                <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha"
                  tooltipPosition="top" formControlName="fecha_fil" (ngModelChange)="limpiarlistacriterio()">
                <hr class="my-1">
              </div>
            </div>


            <div class="col-md-2 ml-3 mt-1">
              <button [disabled]="loading_reporte" type="button" class="custom-out" style="width: 100%;"
                (click)="getcriterio()"><i class="pi pi-filter"></i>
                <b>&nbsp;Filtrar</b>
              </button>
            </div>

            <div class="col-md-2 ml-3 mt-1">
              <button [disabled]="loading_reporte" type="button" class="custom-exc" style="width: 100%;"
                (click)="exportarExcel()"><i class="pi pi-file-excel"></i>
                <b>&nbsp;Exportar</b>
              </button>
            </div>



          </div>
          <hr class="style-two">

          <!-- Tabla con los resultados-->
          <div class="mt-3 ">
            <div class="row d-flex justify-content-center">
              <div class="col-md-3 fst-italic">
                * Dias Trabajados: Rutas, Asistencias Pagadas
              </div>

              <div class="col-6 text-center">
                <h5 class="texto-pesado" style="color:#3b9be9"><b>Listado de Colaboradores</b></h5>
              </div>

              <div class="col-md-3 d-flex justify-content-end mb-2">
                <span class="p-input-icon-left p-ml-auto">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" size="35" (input)="applyFilterGlobal5($event, 'contains')"
                    placeholder="Buscar" tooltipPosition="top" class="form-control"
                    pTooltip="Buscar por nombres, apellidos o clave de colaborador" />
                </span>
              </div>
            </div>
            <p-table #dt5 [value]="lstcriterio" [tableStyle]="{'min-width': '50rem'}" [scrollable]="true"
              scrollHeight="480px" responsiveLayout="scroll" [paginator]="true" [rows]="50"
              [rowsPerPageOptions]="[25,50,75,100,150]" [showCurrentPageReport]="true" [resizableColumns]="false"
              [globalFilterFields]="['nombre_completo', 'cod_chofer']"
              currentPageReportTemplate="{first} a {last} de {totalRecords} Registros" [loading]="loadingcriterio">
              <th pSortableColumn="num_economico">#Economico <p-sortIcon field="num_economico"></p-sortIcon> </th>

              <ng-template pTemplate="header">
                <tr>
                  <th class="text-center">#</th>
                  <th class="text-left" style="width: 200px; min-width: 200px;">Colaborador</th>
                    <th class="text-center" pSortableColumn="clv_truck">¿Es Truck?<p-sortIcon field="clv_truck"></p-sortIcon></th>
                  <th class="text-left" style="width: 50; min-width: 50;">Ciudad</th>
                  <th class="text-center" pSortableColumn="total_dias_trabajados">Dias trabajados<p-sortIcon
                      field="total_dias_trabajados"></p-sortIcon></th>
                  <th Total class="text-center" pSortableColumn="total_kilometros_servicio">Total Kilómetros<p-sortIcon
                      field="total_kilometros_servicio"></p-sortIcon></th>
                  <th class="text-center" pSortableColumn="total_kilometros_restantes">Kilometros Restantes<p-sortIcon
                      field="total_kilometros_restantes"></p-sortIcon></th>
                  <th class="text-center" pSortableColumn="clv_disponible">¿Se Puede Asignar?<p-sortIcon
                      field="clv_disponible"></p-sortIcon></th>
                  <th class="text-center">¿Ruta 1 Dia?</th>
                  <th class="text-center">¿Ruta 2 Dias?</th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-fol>
                <tr>
                  <td class="text-center"><b>{{fol.cod_chofer}}</b>
                  </td>
                  <td class="text-left" style="color: #1e5a9c;">
                    <b>{{fol.nombre_completo}}</b>
                  </td>
                   <td class="text-center"
                    [ngStyle]="{'color': fol?.clv_truck =='SI' ? '#4CAF50FF' : '#e94c3b'}">
                    <b>{{ fol.clv_truck }}</b>
                  </td>
                  <td class="text-left" style="width: 50; min-width: 50;"><b>{{fol.desc_ciudad_hm}}</b></td>
                  <td class="text-center" style="color: #4CAF50FF;"><b>{{fol.total_dias_trabajados}}</b></td>
                  <td class="text-center"><b>{{fol.total_kilometros_servicio}}</b></td>
                  <td class="text-center"><b>{{fol.total_kilometros_restantes}}</b></td>
                  <td class="text-center" [ngStyle]="{'color': fol.clv_disponible == 1 ? '#4CAF50FF' : '#e94c3b'}">
                    <b>{{fol.clv_disponible == 1 ? 'Si' : 'No'}}</b>
                  </td>
                  <td class="text-center"
                    [ngStyle]="{'color': fol?.clv_distancia1 ? '#4CAF50FF' : '#e94c3b'}">
                    <b>{{ fol?.clv_distancia1 ? 'Si' : 'No' }}</b>
                  </td>
                  <td class="text-center"
                    [ngStyle]="{'color': fol?.clv_distancia2 ? '#4CAF50FF' : '#e94c3b'}">
                    <b>{{ fol?.clv_distancia2 ? 'Si' : 'No' }}</b>
                  </td>


                </tr>
              </ng-template>
            </p-table>


          </div>
        </form>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarCriterio();"></button>
      </ng-template>
    </p-dialog>

    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspMantenimiento"
      [style]="{width: '90vw','height':'850px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarMantenimiento()">
      <ng-template pTemplate="header">
        Consulta de Mantenimiento
      </ng-template>

      <ng-template pTemplate="content">

        <div class="row mt-1 d-flex justify-content-start">
          <div class="col-sm-7">
            <span class="title-light2">Filtre para consultar el mantenimiento de las unidades existentes:
              <i class="pi pi-cog" style="size: 2rem;">
              </i>
            </span>
          </div>
        </div>
        <form [formGroup]="consMantenimientoForm">


          <div class="mt-4 d-flex justify-content-around">

            <div class="col-md-3 row">
              <div class="col-md-4">
                <label for="lblligero" class="col-form-label color-font text-right"
                  style="font-weight: 600; font-family: 'Poppins', sans-serif;">
                  <span class="input-group-addon"> <i class="pi pi-map color-icon mr-3"
                      style="font-size: 2rem; color: #3B82F6;"></i>
                  </span>
                  Ciudad
                </label>
              </div>
              <div class="col-md-8 mt-1">

                <p-dropdown [options]="lstCiudades" autoWidth="false" [style]="{'width':'100%'}"
                  placeholder="Seleccione Ciudad*" formControlName="id_ciudad_hm" optionLabel="nombre"
                  [showClear]="true" optionValue="id"></p-dropdown>
                <hr class="my-1">

              </div>
            </div>

            <!-- <div class="col-md-3 row">
              <div class="col-md-4">
                <label for="lblligero" class="col-form-label color-font text-right"
                  style="font-weight: 600; font-family: 'Poppins', sans-serif;">
                  <span class="input-group-addon"> <i class="pi pi-calendar color-icon mr-3"
                      style="font-size: 2rem; color: #3B82F6;"></i>
                  </span>
                  Fecha
                </label>
              </div>
              <div class="col-md-8 mt-2">
                <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha"
                  tooltipPosition="top" formControlName="fecha_fil" (ngModelChange)="limpiarlistacriterio()">
                <hr class="my-1">
              </div>
            </div> -->

            <div class="col-md-2 ml-3 mt-1">
              <button [disabled]="loadingManetnimiento" type="button" class="custom-out" style="width: 100%;"
                (click)="getMantenimiento()"><i class="pi pi-filter"></i>
                <b>&nbsp;Filtrar</b>
              </button>
            </div>

            <div class="col-md-2 ml-3 mt-1">
              <button [disabled]="loadingManetnimiento_reporte" type="button" class="custom-exc" style="width: 100%;"
                (click)="exportarExcelMantenimiento()"><i class="pi pi-file-excel"></i>
                <b>&nbsp;Exportar</b>
              </button>
            </div>



          </div>
        </form>

          <hr class="style-two">

          <!-- Tabla con los resultados-->
          <div class="mt-3 ">
            <div class="row d-flex justify-content-center">
              <!-- <div class="col-md-3 fst-italic">
                * Dias Trabajados: Rutas, Asistencias Pagadas
              </div> -->

              <div class="col-6 text-center">
                <h5 class="texto-pesado" style="color:#3b9be9"><b>Listado de Unidades</b></h5>
              </div>

              <div class="col-md-3 d-flex justify-content-end mb-2">
                <span class="p-input-icon-left p-ml-auto">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" size="35" (input)="applyFilterGlobal5($event, 'contains')"
                    placeholder="Buscar" tooltipPosition="top" class="form-control"
                    pTooltip="Buscar por Economico, Ciudad" />
                </span>
              </div>
            </div>
            <p-table #dt5 [value]="lstManteniento" [tableStyle]="{'min-width': '50rem'}" [scrollable]="true"
              scrollHeight="480px" responsiveLayout="scroll" [paginator]="true" [rows]="50"
              [rowsPerPageOptions]="[25,50,75,100,150]" [showCurrentPageReport]="true" [resizableColumns]="false"
              [globalFilterFields]="['num_economico','ciudad']"
              currentPageReportTemplate="{first} a {last} de {totalRecords} Registros" [loading]="loadingManetnimiento">
              <th pSortableColumn="num_economico">#Economico <p-sortIcon field="num_economico"></p-sortIcon> </th>

              <ng-template pTemplate="header">
                <tr>
                  <!-- <th class="text-center">#</th> -->
                  <th class="text-left" style="width: 100; min-width: 100px;">Número Económico</th>
                  <th class="text-left" style="width: 50; min-width: 50;">Ciudad</th>
                  <th class="text-left" pSortableColumn="desc_estatus">Estatus<p-sortIcon
                      field="desc_estatus"></p-sortIcon></th>
                  <th class="text-center" pSortableColumn="kim_final_carga">Kilometraje Actual<p-sortIcon
                      field="kim_final_carga"></p-sortIcon></th>
                  <th Total class="text-center" pSortableColumn="kim_ultimo_mantenimiento">Kilometraje Último Mantenimiento<p-sortIcon
                      field="kim_ultimo_mantenimiento"></p-sortIcon></th>
                  <th class="text-center" pSortableColumn="kim_mantenimiento">Kilómetros para Mantenimiento<p-sortIcon
                      field="kim_mantenimiento"></p-sortIcon></th>
                  <th class="text-center" pSortableColumn="proximo_mantenimiento">Próximo Mantenimiento<p-sortIcon
                      field="proximo_mantenimiento"></p-sortIcon></th>
                  <th class="text-center" pSortableColumn="kim_restantes">Kilometros Restantes<p-sortIcon
                      field="kim_restantes"></p-sortIcon></th>
                  <!-- <th class="text-center">¿Ruta 1 Dia?</th>
                  <th class="text-center">¿Ruta 2 Dias?</th> -->

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-fol>
                <tr>
                  <!-- <td class="text-center"><b>{{fol.cod_chofer}}</b> -->
                  <!-- </td> -->
                  <td class="text-left" style="color: #1e5a9c;">
                    <b>{{fol.num_economico}}</b>
                  </td>
                  <td class="text-left" style="width: 50; min-width: 50;"><b>{{fol.ciudad}}</b></td>
                  <td class="text-left" style="width: 50; min-width: 50;"><b>{{fol.desc_estatus}}</b></td>
                  <td class="text-center" style="color: #4CAF50FF;"><b>{{fol.kim_final_carga}}</b></td>
                  <td class="text-center"><b>{{fol.kim_ultimo_mantenimiento}}</b></td>
                  <td class="text-center"><b>{{fol.kim_mantenimiento}}</b></td>
                  <td class="text-center"><b>{{fol.proximo_mantenimiento}}</b></td>
                  <td class="text-center"><b>{{fol.kim_restantes}}</b></td>
                  <!-- <td class="text-center" [ngStyle]="{'color': fol.clv_disponible == 1 ? '#4CAF50FF' : '#e94c3b'}">
                    <b>{{fol.clv_disponible == 1 ? 'Si' : 'No'}}</b>
                  </td> -->
                  <!-- <td class="text-center"
                    [ngStyle]="{'color': fol?.total_dias_trabajados <= 5 ? '#4CAF50FF' : '#e94c3b'}">
                    <b>{{ fol?.total_dias_trabajados <= 5 ? 'Si' : 'No' }}</b>
                  </td>
                  <td class="text-center"
                    [ngStyle]="{'color': fol?.total_dias_trabajados <= 4 ? '#4CAF50FF' : '#e94c3b'}">
                    <b>{{ fol?.total_dias_trabajados <= 4 ? 'Si' : 'No' }}</b>
                  </td> -->


                </tr>
              </ng-template>
            </p-table>


          </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarMantenimiento();"></button>
      </ng-template>
    </p-dialog>

    <!-- ---------Servicios sin Finalizar-------------------- -->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspServicios"
      [style]="{width: '90vw','height':'1000px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarCriterio()">
      <ng-template pTemplate="header">
        Servicios Sin Finalizar al {{fecha_filtrada}}
      </ng-template>
      <ng-template pTemplate="content">
        <div class="col d-flex justify-content-end ml-auto mt-3">
          <div class="col text-center">
            <h5 class="texto-pesado" style="color:#3b9be9">
              <b>Listado de Servicios Sin Finalizar por Operaciones</b>
            </h5>
          </div>
          <div class="d-flex justify-content-end mr-6">
            <button pButton pRipple type="button" (click)="ComprobarServicio();" label="&nbsp;&nbsp;&nbsp;Cargar&nbsp;&nbsp;&nbsp;" class="btn custom-sinFinalizar"
              icon="pi pi-filter" iconPos="right"></button>
          </div>
        </div>
        <!-- Tabla con los resultados-->
        <div class="mt-3 ">
          <p-table #dt6 [value]="ServiciosSinFinalizar" [scrollable]="true" [paginator]="true" [rows]="50"
            scrollDirection="" scrollHeight="600px" [ngStyle]="{'min-width': '100%', 'max-width': '100%'}"
            [rowsPerPageOptions]="[25,50,75,100,150]" [showCurrentPageReport]="true" [resizableColumns]="false"
            [globalFilterFields]="['nombre_chofer','nom_ciudad','num_economico','num_folio','nom_ruta','clave_ruta']"
            currentPageReportTemplate="{first} a {last} de {totalRecords} Registros" [loading]="loadingServicios">
            <ng-template pTemplate="caption">
              <div class="flex flex-row-reverse flex-wrap">
                <span class="p-input-icon-left p-ml-auto">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" size="50" (input)="applyFilterGlobal6($event, 'contains')"
                    placeholder="Buscar Chofer,Numero Economico,Folio,Ciudad,Ruta" />
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th class="text-center">Clave Ruta</th>
                <th class="text-center">Nombre de la Ruta</th>
                <th class="text-center">Ciudad</th>
                <th class="text-center">#Num Economico</th>
                <th class="text-center">Nombre del Chofer</th>
                <th class="text-center">Descripcion Estatus</th>
                <th class="text-center">Acción</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
              <tr>
                <td class="text-center"><b>{{data.clave_ruta}}</b></td>
                <td class="text-center"><b>{{data.nom_ruta}}<br />
                    <p style="display: inline-block; color: green !important;font-weight: bold;justify-self: start;">
                      #Folio: {{data.num_folio}}</p>
                  </b>
                </td>
                <td class="text-center"><b>{{data.nom_ciudad}}</b></td>
                <td class="text-center"><b>{{data.num_economico}}</b></td>
                <td class="text-center"><b>{{data.nombre_chofer}}</b></td>
                <td class="text-center"><b style="color: #e94c3b;">{{data.des_estatus}}<i
                      class="pi pi-exclamation-circle"></i></b></td>
                <td class="text-center"><b>
                    <div *ngIf=" data.clv_fin_operacion !=1 ">
                      <button type="button" class="btn custom-finalizar" (click)="finalizaroperacion(data, 1,0)"
                        pTooltip="Finalizar por Operaciones" tooltipPosition="top">
                        Finalizar&nbsp;<i class="pi pi-check">&nbsp;</i>
                      </button>
                    </div>
                  </b>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarServicios();"></button>
      </ng-template>
    </p-dialog>


  </div>
</div>
